export default __webpack_public_path__ + "static/media/rectangle-line.b95e8721.svg";